var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckMark(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7253 0.305528C14.9012 0.501216 15 0.766591 15 1.04329C15 1.32 14.9012 1.58537 14.7253 1.78106L5.81208 11.6945C5.63614 11.8901 5.39754 12 5.14875 12C4.89997 12 4.66137 11.8901 4.48542 11.6945L0.263374 6.99865C0.0924668 6.80184 -0.00210222 6.53824 3.54675e-05 6.26463C0.00217316 5.99103 0.100846 5.7293 0.274802 5.53582C0.448758 5.34235 0.684079 5.2326 0.930081 5.23022C1.17608 5.22785 1.41308 5.33303 1.59003 5.52311L5.14875 9.48117L13.3986 0.305528C13.5746 0.109899 13.8132 0 14.062 0C14.3108 0 14.5494 0.109899 14.7253 0.305528Z",
    fill: "#15DA28"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMark);
export default __webpack_public_path__ + "static/media/CheckMark.634a868ccf4ff8dad5039f4d0a30b377.svg";
export { ForwardRef as ReactComponent };